import {environment} from "~/env";
import {B} from "~/build";

/** The Local Storage suffix the remembered Spend Landscape filters are kept under. */
const FILTERS_KEY_SUFFIX = 'BagAdvancedInsightsManager.filter';

/**
 * The key for the Local Storage where the filters are stored.
 * When developing a unique key is used to ensure that the filters are reset.
 */
export const LOCAL_STORAGE_KEY_FILTERS = `${environment.production ? '' : (B.APP_VERSION + '.')}${FILTERS_KEY_SUFFIX}`;

/**
 * Forgets the remembered filters (ids of suppliers and categories of the customer's data), whatever app version saved
 * them. Called when the session ends, so the next person on this browser does not inherit them.
 */
export function clearSavedSpendLandscapeFilters(): void {
    try {
        const keys = Array.from({length: localStorage.length}, (_, i) => localStorage.key(i));
        keys.filter((k): k is string => k !== null && k.endsWith(FILTERS_KEY_SUFFIX))
            .forEach(k => localStorage.removeItem(k));
    } catch {
        // Storage can be blocked (private window, site data off): nothing was saved then
    }
}
